/* tslint:disable */

/**
 */
export class DailyView {
    license_plates?: string;
    driver_name?: string;
    subdriver_name?: string;
    route_name?: string;
    total_price_pos?: number;
    total_price_charge?: number;
    total_price_deposit?: number;
    total_revenue?: number;
}
